import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import appSelectors from "redux/app/appSelectors";

import { setTranslation } from "redux/app/appSlice";

import en from 'translations/en.json';
import ru from 'translations/ru.json';

const translation = { en, ru };

const useTranslation = () => {
  const dispatch = useDispatch();
  const lang = useSelector(appSelectors.language);

  useEffect(() => {
    if (lang) dispatch(setTranslation(translation[lang]));
  }, [dispatch, lang]);

}

export default useTranslation